import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface PickupThing {
  id: string | number;
  title: string;
  description?: string;
  icon?: string;
  iconSrc?: string; // For image-based icons
  iconColor?: string;
  backgroundColor?: string;
  actionText?: string;
  actionLink?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-pickup-things',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './pickup-things.component.html',
  styleUrl: './pickup-things.component.scss',
})
export class PickupThingsComponent {
  @Input() title: string = 'Things you can pick up';
  @Input() items: PickupThing[] = [];
  @Input() columns: number = 2;

  defaultItems: PickupThing[] = [
    // Notebook card - commented out for single row layout
    // {
    //   id: 1,
    //   title: 'Create Your Notebook & Start Building',
    //   description: 'Launch your own notebook to explore data.',
    //   icon: '<path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 9H9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    //   iconColor: '#f5f5f5',
    //   backgroundColor: '#ffffff',
    //   actionText: 'Create Notebook',
    //   actionLink: '#'
    // },
    {
      id: 1,
      title: 'Explore Real-World Usecases',
      description: 'Access usecase library to inspire your next innovation.',
      iconSrc: '/icons/research.svg',
      iconColor: '#e8f4f9',
      backgroundColor: '#ffffff',
      actionText: 'Browse',
      actionLink: '/usecases'
    },
    {
      id: 2,
      title: 'Dive into Datasets',
      description: 'Discover a rich collection of insightful health-related datasets.',
      iconSrc: '/icons/dataset.svg',
      iconColor: '#e8f4f9',
      backgroundColor: '#ffffff',
      actionText: 'Browse',
      actionLink: '/datasets'
    },
    {
      id: 3,
      title: 'Discover Models',
      description: 'Explore, test & contribute models for real-world applications.',
      iconSrc: '/icons/models.svg',
      iconColor: '#e8f4f9',
      backgroundColor: '#ffffff',
      actionText: 'Browse',
      actionLink: '/models'
    },
    {
      id: 4,
      title: 'Discover Challenges',
      description: 'Find and tackle real-world problems with AI solutions.',
      iconSrc: '/icons/challenges.svg',
      iconColor: '#e8f4f9',
      backgroundColor: '#ffffff',
      actionText: 'Browse',
      actionLink: '/challenges'
    }
  ];

  constructor(private sanitizer: DomSanitizer) {}

  getSafeIcon(icon?: string): SafeHtml | undefined {
    return icon ? this.sanitizer.bypassSecurityTrustHtml(icon) : undefined;
  }

  /** True when navigation should use href (not Angular router). */
  isExternalUrl(link: string): boolean {
    return (
      /^https?:\/\//i.test(link) ||
      link.startsWith('//') ||
      /^mailto:/i.test(link) ||
      /^tel:/i.test(link)
    );
  }

  /** New tab only for web URLs; not for mailto/tel. */
  opensInNewTab(link: string): boolean {
    return /^https?:\/\//i.test(link) || link.startsWith('//');
  }

  get displayItems(): PickupThing[] {
    return this.items.length > 0 ? this.items : this.defaultItems;
  }
}
